module.exports = __webpack_public_path__ + "static/media/login-cover-image.02704559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login-cover-image.jpg
// module id = 1919
// module chunks = 0